var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ZyroImageSelector',{attrs:{"value":_vm.currentImage},on:{"input":function($event){_vm.currentImage = $event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }